import React from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { Button } from '../../../../components/Common/UI/Button';
import Icons from '../../../../components/Common/Icons/Icons';
import { cn } from '../../../../utils/styles';
import { PdfViewerTrigger } from '../../../../context/pdfViewerDialog';

const footerMenu: string[] = ['Copyright/IP Policy', 'Terms of Service', 'Site Map', 'Send Feedback', 'Contact Us'];

interface IFooter {
  className?: string;
}

function Footer({ className }: IFooter) {
  return (
    <div className={cn('border bg-addition6-3 p-[20px] rounded-[10px] grid gap-[15px] mb-[20px]', className)}>
      <div className="text-[18px] font-bold uppercase">
        DEMO INSTITUTION AGREEMENT TO RECEIVE DISCLOSURES ELECTRONICALLY
      </div>
      <div>
        This is an online version of your printed statements. Your eStatements are posted on a monthly basis, and you
        will receive an email notification once it is available for viewing. You will accumulate up to 12 months of
        statements. To view your statement, you need to have Abobe Acrobat Reader installed on your computer.
      </div>
      <div
        className="flex lg:flex-row flex-col lg:gap-[10px] gap-[20px] justify-between
      lg:items-center items-start lg:mb-0 mb-[20px]"
      >
        <PdfViewerTrigger src="/guidance/disclosure.pdf">
          <Button className="!bg-white py-[8px] px-[35px] h-[44px] !text-secondary">Disclosure</Button>
        </PdfViewerTrigger>
        <div className="flex md:gap-[30px] gap-[15px] md:items-center md:flex-row flex-col">
          <div className="font-bold text-[18px]">Need Help?</div>
          <Link to="#" className="underline text-addition6 font-medium flex gap-[10px] items-center">
            <Icons.Mail className="[&_path]:fill-addition6" />
            info@guidance.com
          </Link>
          <Link to="#" className="underline text-addition6 font-medium flex gap-[10px] items-center">
            <Icons.Phone className="[&_path]:fill-addition6" />
            (650) 473-6388
          </Link>
        </div>
      </div>
      <div className="flex justify-between xl:items-center xl:flex-row flex-col">
        <div className="flex last:[&_a]:after:hidden lg:flex-row flex-col lg:gap-0 gap-[10px]">
          {footerMenu.map(el => (
            <Link
              to="#"
              key={el}
              className="underline flex items-center text-addition6 font-medium
              lg:after:h-[12px] lg:after:w-[1px] lg:after:bg-secondary-50 lg:after:mx-[10px]"
            >
              {el}
            </Link>
          ))}
        </div>
        <div className="text-xs text-addition1-50 xl:mt-[0] mt-[20px]">{`Copyright © ${dayjs().format('YYYY')} Guidance Financial Inc. All rights reserved.`}</div>
      </div>
    </div>
  );
}

Footer.defaultProps = {
  className: '',
};

export default Footer;
